<template>
	<div class="d-flex flex-wrap align-items-stretch mt-2">

		<widget style="flex-grow: 1;" class="report-panel feature-numbers bg-white">
			<div class="feature-number">
				<div class="feature-number-value">
					{{totalProfitMargin ? totalProfitMargin.toFixed(1) : 0}} %
				</div>
				<div class="feature-number-label">
					Gross Profit Margin
				</div>
			</div>
			<div class="feature-number">
				<div class="feature-number-value">
					$ {{totalProfit ? totalProfit.toCurrency() : 0}}
				</div>
				<div class="feature-number-label">
					<div class="d-flex flex-row align-items-center justify-content-center">
						<div class="legend-item" style="background-color: #7abd4a;margin-right: 10px;"></div>
						<span>Gross Profit</span>
					</div>
				</div>
			</div>
			<div class="feature-number">
				<div class="feature-number-value">
					$ {{totalRevenue ? totalRevenue.toCurrency() : 0}}
				</div>
				<div class="feature-number-label">
					Revenue
				</div>
			</div>
		</widget>

		<widget style="flex-grow: 1;" class="report-panel">
			<div class="d-flex align-items-stretch flex-wrap justify-content-around" style="height: 100%;">
				<div class="report-chart">
					<div class="chart-js">

						<chart v-if="showChart && showChartLocal" type="bar"
							:data="chartData"
							height="400"
							:labels="[
								'Materials',
								'Labour',
								'Equipment',
								'Permits',
								'Expenses',
								'Gross Profit'
							]"
							:background-color="[
								'#ECBA00',
								'#25241F',
								'#D3CCB3',
								'#88867F',
								'#ebdbab',
								'#7abd4a'
							]"
							:options="{
								responsive: false,
								cutoutPercentage: 70,
								legend: {
									position: 'bottom',
									display: false
								}
							}">
						</chart>
					</div>
				</div>
				<div class="report-costs d-flex flex-column align-items-center">
					<div style="margin: auto">
						
						<table class="costs-table">
							<tr>
								<td colspan="2">
									<h2 class="report-heading" style="margin-bottom: 0;">Service Costs</h2>
								</td>
								<td class="text-right"><strong>{{totalCosts.toCurrency()}}</strong></td>
								<td></td>
							</tr>
							<tr style="">
								<td><div class="legend-item" style="background-color: #ECBA00"></div></td>
								<th>Materials</th>
								<td class="text-right">{{totalMaterialCost ? totalMaterialCost.toCurrency() : '0.00'}}</td>
								<td><a href="#" v-on:click.prevent="seeDetails('Material')"><i class="fa fa-info-circle"></i></a></td>
							</tr>
							<tr style="">
								<td><div class="legend-item" style="background-color: #25241F"></div></td>
								<th>Labour</th>
								<td class="text-right">{{totalLabourCost ? totalLabourCost.toCurrency() : '0.00'}}</td>
								<td><a href="#" v-on:click.prevent="seeDetails('Labour')"><i class="fa fa-info-circle"></i></a></td>
							</tr>
							<tr style="">
								<td><div class="legend-item" style="background-color: #D3CCB3"></div></td>
								<th>Equipment</th>
								<td class="text-right">{{totalEquipmentCost ? totalEquipmentCost.toCurrency() : '0.00'}}</td>
								<td><a href="#" v-on:click.prevent="seeDetails('Equipment')"><i class="fa fa-info-circle"></i></a></td>
							</tr>
							<tr style="">
								<td><div class="legend-item" style="background-color: #88867F"></div></td>
								<th>Permits</th>
								<td class="text-right">{{totalPermitsCost ? totalPermitsCost.toCurrency() : '0.00'}}</td>
								<td><a href="#" v-on:click.prevent="seeDetails('Permit')"><i class="fa fa-info-circle"></i></a></td>
							</tr>
							<tr>
								<td colspan="4"><hr></td>
							</tr>
							<tr style="">
								<td><div class="legend-item" style="background-color: #ebdbab"></div></td>
								<th>Submitted Expenses *</th>
								<td class="text-right">{{totalSubmittedExpenses ? totalSubmittedExpenses.toCurrency() : '0.00'}}</td>
								<td><a href="#" v-on:click.prevent="seeDetails('Submitted')"><i class="fa fa-info-circle"></i></a></td>
							</tr>
							<tr style="">
								<td><div class="legend-item" style="background-color: #ebdbab"></div></td>
								<th>Service Task Costs **</th>
								<td class="text-right">{{totalServiceTaskCost ? totalServiceTaskCost.toCurrency() : '0.00'}}</td>
								<td><a href="#" v-on:click.prevent="seeDetails('Service Tasks')"><i class="fa fa-info-circle"></i></a></td>
							</tr>
							<tr>
								<td colspan="4" style="text-transform: none;font-size: 10pt;">
									<p>* Submitted expenses not included in Gross Profit calculation</p>

									<p>** Service tasks not included in Service Costs Total calculation</p>

									<p>
										NOTE: The information on this report is derived from the approved time logs and the items entered into the worksheet. The accuracy of this report depends on the accuracy of the information input into this system in the correct location.
									</p>
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</widget>

		<modal-dialog
			:modal-visible="detailsModal.visible"
			:title="detailsModal.title"
			:submit-visible="false"
			modal-size="modal-lg"
			cancel-button-text="Done"
			v-on:closeModal="detailsModal.visible = false">

			<spinner v-if="detailsModal.working" :inline="true"></spinner>

			<table-list
				v-else
				:record-name="detailsModal.recordName"
				:fields="detailsModal.fields"
				:records="detailsModal.records">
			</table-list>

			<p v-if="detailsModal.recordName == 'Time Log'" class="text-muted">NOTE: Time logs are not counted towards cost until they are reviewed and submitted</p>

		</modal-dialog>
	</div>
</template>
<script type="text/javascript">

import Chart from "@/components/Chart"
import Widget from "@/components/Widget"
import ModalDialog from "@/components/ModalDialog"
import TableList from "@/components/TableList"
import Spinner from "@/components/Spinner"

export default {
	name: "ServiceReportSummary",
	components: {
		Chart,
		Widget,
		ModalDialog,
		TableList,
		Spinner
	},
	props: [
		"totalRevenue",
		"totalProfit",
		'totalProfitMargin',
		'totalPermitsCost',
		'totalEquipmentCost',
		'totalLabourCost',
		'totalMaterialCost',
		'totalSubmittedExpenses',
		"totalServiceTaskCost",
		"showChart",
		'chartData',
		"serviceIds",
		"Spinner"
	],
	data() {
		return {
			showChartLocal: false,
			detailsModal: {
				visible: false,
				title: "",
				fields: [],
				records: [],
				recordName: "",
				working: false
			}
		}
	},
	computed: {
		totalCosts() {
			let tot = this.totalPermitsCost+this.totalEquipmentCost+this.totalLabourCost+this.totalMaterialCost//+this.totalSubmittedExpenses

			return tot
		}
	},
	watch: {
		chartData() {
			let vm = this
			this.showChartLocal = false

			setTimeout(()=>{
				vm.showChartLocal = true
			},100)
		}
	},
	methods: {
		seeDetails(type) {
			let vm = this

			this.detailsModal.visible = true
			this.detailsModal.title = type+" Expense Details"
			this.detailsModal.records = []

			if (type == 'Material') {
				this.detailsModal.fields = [
					{label: "Part Number",key:"part_number"},
					{label: "Description", key: "description"},
					{label: "Qty",key:'qty',align:"right"},
					{label: "Cost",key:"totalCost",align:"right"}
				]
				this.detailsModal.recordName = "Material"

				let params = {
					filters: [["id",this.serviceIds]],
					fields: ["id","slug"],
					include: ["ServiceWorksheet"]
				}

				let materials = []
				let totalCostAll = 0
				this.getJSON("Service/get",params,true).then(response => {
					if (response.success) {
						response.data.forEach(service => {

							if ("ServiceWorksheet" in service && service.ServiceWorksheet) {
								service.ServiceWorksheet.forEach(ws => {
									try {
										let serviceMaterials = JSON.parse(ws.parts_used_json)

										serviceMaterials.forEach(mat => {
											let totalCost = 0

											let per = 1
											if ("per" in mat)
												per = +mat.per

											if ("price" in mat && "qty" in mat) {
												totalCost = (+mat.price) * (+mat.qty) / +per
											}

											totalCostAll += totalCost

											materials.push({
												part_number: "part_number" in mat ? mat.part_number : "",
												description: "description" in mat ? mat.description : "",
												qty: "qty" in mat ? mat.qty : "",
												totalCost: totalCost.toCurrency()
											})
										})
									}
									catch (e) {}
								})
							}
						})

						materials.push({
							tfoot: true,
							part_number: "",
							description: "",
							qty: "Total",
							totalCost: totalCostAll.toCurrency()
						})
						this.detailsModal.records = materials
					}
				})
			}
			else if (type == "Equipment") {
				this.detailsModal.fields = [
					{label: "Equipment Type",key: 'typeName'},
					{label: "Qty",key:'qtyWithUnits'}
				]
				this.detailsModal.recordName = "Equipment"

				let params = {
					filters: [
						["service_id",this.serviceIds]
					]
				}

				let equipmentUsed = []
				this.getJSON("ServiceWorksheet/get",params).then(response => {
					if (response.success) {
						response.data.forEach(worksheet => {
							let eq = []
							try {
								eq = JSON.parse(worksheet.equipment_used_json)
							}
							catch (e) {}

							equipmentUsed = [
								...equipmentUsed,
								...eq
							]
						})

						//condense down to type
						let typesUsed = []
						equipmentUsed.forEach(eq => {

							let type = eq.EquipmentType
							let multiRates = {}
							let rate = 0
							let eqUnit = "hour"
							if ("charge_out_rate_unit" in type) {
								if (eq.EquipmentType.charge_out_rate_unit == 'hrs')
									eqUnit = "hours"

								else
									eqUnit = type.charge_out_rate_unit
							}
							if ("charge_out_rates_json" in type) {
								
								if ("unit" in type)
									eqUnit = type.unit
								else if ("qty_unit" in type)
									eqUnit = type.qty_unit

								if (eqUnit == 'hours' || eqUnit == 'hrs')
									eqUnit = "hour"

								try {
									multiRates = JSON.parse(type.charge_out_rates_json)

									if (eqUnit in multiRates) {
										rate = multiRates[eqUnit].rate
									}
								}
								catch (e) {}
								
							}

							

							let typeIndex = typesUsed.findIndex(type => type.id == eq.type_id && type.qtyUnit == eqUnit)
							if (typeIndex >= 0) {
								typesUsed[typeIndex].qty += +eq.qty

								typesUsed[typeIndex].qtyWithUnits = typesUsed[typeIndex].qty + " "+eqUnit
							}
							else {
								let typeObj = {
									id: eq.type_id,
									typeName: eq.EquipmentType.name,
									qtyUnit: eqUnit
								}

								typeObj.qty = +eq.qty

								typeObj.qtyWithUnits = typeObj.qty + " " + eqUnit

								typesUsed.push(typeObj)
							}

						})

						vm.detailsModal.records = typesUsed
					}
				})
			}
			else if (type == "Labour") {
				this.detailsModal.fields = [
					{label: "Employee",key:"employeeName"},
					{label: "Hrs",key:'hrs',align:"right"}
				]
				this.detailsModal.recordName = "Time Log"

				let params = {
					filters: [
						["service_id",this.serviceIds],
						["submitted_by >",0]
					],
					fields: ["id","slug","user_id","regular_hours","overtime_hours_15x","overtime_hours_2x","overtime_hours_25x"],
					include: [
						{model:"User",fields:["id","slug","first_name","last_name"]},
						{model: "CollectiveAgreement",fields:["id","slug","payscales"]}
					]
				}

				this.detailsModal.working = true

				this.getJSON("TimeLog/get",params,true).then(response => {
					if (response.success) {
						let totalTime = 0

						vm.detailsModal.records = response.data.map(log => {
							log.employeeName = log.User.first_name+" "+log.User.last_name

							let hrs = parseFloat(log.regular_hours) + parseFloat(log.overtime_hours_15x) + parseFloat(log.overtime_hours_2x) + parseFloat(log.overtime_hours_25x)

							totalTime += hrs

							log.hrs = hrs.toFixed(2)	

							return log
						})

						vm.detailsModal.records.push({
							tfoot:true,
							employeeName: "",
							hrs: "Total "+totalTime+ " hrs"
						})
					}
					vm.detailsModal.working = false
				})
			}
			else if (type == "Submitted") {
				this.detailsModal.fields = [
					{label: "Description",key:"description"},
					{label: "Vendor",key:"vendor"},
					{label: "Subtotal",key:"cost",align:"right"},
					{label: "Total",key:"totalCost",align:"right"}
				]
				this.detailsModal.recordName = "Expense"

				let params = {
					filters: [
						["service_id",this.serviceIds]
					],
					//include: [{model: "User",fields:["slug","id","first_name","last_name"]}]
				}

				this.detailsModal.working = true

				this.getJSON("Expense/get",params,true).then(response => {
					if (response.success) {
						let subtotalAll = 0
						let grandTotalAll = 0

						vm.detailsModal.records = response.data.map(expense => {
							let totalCost = parseFloat(expense.cost) + parseFloat(expense.tax) + parseFloat(expense.tip)

							expense.totalCost = totalCost.toCurrency()

							subtotalAll += +expense.cost
							grandTotalAll += totalCost

							return expense
						})

						vm.detailsModal.records.push({
							tfoot: true,
							description: "",
							vendor: "Total",
							cost: subtotalAll.toCurrency(),
							totalCost: grandTotalAll.toCurrency()
						})
					}
					vm.detailsModal.working = false
				})
			}
			else if (type == "Permit") {
				this.detailsModal.recordName = "Permit"

				this.detailsModal.fields = [
					{label: "Service #",key:"jobLabel"},
					{label: "Permit Notification #",key:"permit_notification_number"},
					{label: "Cost",key:"permit_cost",align:"right"}
				]

				let params = {
					filters: [
						["id",this.serviceIds]
					],
					fields: ["id","slug","permit_cost","Customer","permit_notification_number","job_num","customer_name_cache"]
				}

				this.getJSON("Service/get",params,true).then(response => {
					if (response.success) {
						let totalCost = 0

						vm.detailsModal.records = response.data.filter(service => service.permit_cost && parseFloat(service.permit_cost) != 0).map(service => {
							let jobLabel = service.job_num

							if ("customer_name_cache" in service)
								jobLabel = service.job_num+": "+service.customer_name_cache

							totalCost += +service.permit_cost

							return {
								jobLabel: jobLabel,
								permit_notification_number: service.permit_notification_number,
								permit_cost: service.permit_cost
							}
						})
						this.detailsModal.records.push({
							tfoot: true,
							jobLabel: "",
							permit_notification_number: "Total",
							permit_cost: totalCost.toCurrency()
						})
					}
				})
			}
			else if (type == 'Service Tasks') {
				this.detailsModal.recordName = "Service Task"

				this.detailsModal.fields = [
					{label: "Task #",key:"item_number"},
					{label: "Description",key:"description"},
					{label: "Cost",key:"unit_cost",align:"right"},
					{label: "Qty",key:"qty",align:"right"},
					{label: "Total",key:"totalItemCost",align:"right"},
				]

				let params = {
					filters: [
						["service_id",this.serviceIds]
					],
				}

				this.getJSON("ServiceWorksheet/get",params).then(response => {
					console.log(response)

					let compiledRecords = []

					if (response.success) {
						response.data.forEach(ws => {
							try {
								let tasks = JSON.parse(ws.service_tasks_completed_json)

								tasks.forEach(task => {
									let matchingIndex = compiledRecords.findIndex(compiledTask => compiledTask.item_number == task.item_number && compiledTask.unit_cost == task.unit_cost)

									if (matchingIndex >= 0) {
										compiledRecords[matchingIndex].qty += +task.qty

										compiledRecords[matchingIndex].totalItemCost = compiledRecords[matchingIndex].qty * +task.unit_cost
									}
									else {
										let qty = +task.qty
										task.qty = qty

										let totalItemCostRaw = +task.unit_cost * +task.qty
										let totalItemCost = totalItemCostRaw.toCurrency()

										compiledRecords.push({
											item_number: task.item_number,
											description: task.description,
											unit_cost: task.unit_cost, 
											qty: task.qty,
											totalItemCostRaw,
											totalItemCost
										})
									}
								})
							}
							catch (e) {}
						})
					}

					this.detailsModal.records = compiledRecords
				})
			}

		}
	},
	created() {
		let vm = this

		if (this.showChart) {
			setTimeout(()=>{
				vm.showChartLocal = true
			},100)
		}
	}
}
</script>

<style type="text/css" scoped>
	.report-heading {
		color: #88867F;
		text-transform: uppercase;
		font-size: 14pt;
	}

	.chart-js {
		/*background-color: rgba(207,216,220,0.4);*/
		padding: 20px;
	}

	.report-panel {
		margin-right: 5px;
		margin-left: 5px;
	}

	.feature-numbers {
		width: 300px;
		text-align: center;
		padding: 10px;
		background-color: #F6F6F6;
	}

	.feature-number {
		margin-bottom: 50px;
		margin-top: 50px;
	}

	.feature-number-label, .feature-number-value {
		text-transform: uppercase;
		color: #88867F;
	}

	.feature-number-label {
		font-size: 14pt;
	}

	.feature-number-value {
		font-size: 30pt;
		line-height: 40px;
	}

	.report-costs, .report-chart {
		width: 50%;
	}

	.costs-table {
		border-collapse: collapse;
		text-transform: uppercase;
		color: #88867F;

	}

	.costs-table th {
		font-size: 14pt;
		font-weight: normal;
		padding: 5px;
		padding-left: 10px;
		padding-right: 10px;
	}

	.costs-table td {
		font-size: 16pt;
		padding: 5px;
	}

	.legend-item {
		width: 20px;
		height: 20px;
		border-radius: 50%;
	}

	@media (max-width: 1024px) {
		.report-panel {
			width: 100%;
			margin-right: 0;
		}

		.feature-numbers {
			margin-right: 0;
		}
	}

	@media (max-width: 650px) {
		.report-costs, .report-chart {
			width: 100%;
		}
	}
</style> 